import { useAppDispatch } from '@core/redux/hooks';
import {
  decreaseLoading,
  increaseLoading,
} from '@features/layout/store/layout.slice';
import { users } from '@service/api';
import { TakeSkipFilter } from '@typings';
import { useState } from 'react';

import OpenNotification from '../components/antd/OpenNotification';

interface IUsersCount {
  total: number;
  users: any[];
}

export const useUsers = () => {
  const dispatch = useAppDispatch();
  const [activeUsers, setActiveUsers] = useState<IUsersCount>();
  const [pagination, setPagination] = useState<{ current: number }>({
    current: 1,
  });
  const [filter, setFilter] = useState<{
    name: {
      iLike: string;
    };
  }>();

  const getAllActiveUsers = async (props?: TakeSkipFilter) => {
    try {
      dispatch(increaseLoading());
      if (!props) {
        props = {
          skip: 0,
          take: 10,
        };
      }
      const response = await users.getAllActiveUsers(props);

      setActiveUsers(response);
    } catch (error) {
      console.log(error);
      OpenNotification(true, 'Falha ao carregar usuários ativos');
    } finally {
      dispatch(decreaseLoading());
    }
  };

  const changePage = (page: number) => {
    const takeNumber = 10;
    setPagination({ current: page });
    getAllActiveUsers({
      filter: { ...filter },
      take: takeNumber,
      skip: page * takeNumber,
    });
  };

  const filterUsers = (userName = '') => {
    if (!activeUsers) return;
    const takeNumber = 10;

    const filterObj = {
      name: { iLike: `%${userName.replace(' ', ' %')}%` },
    };

    setFilter(filterObj);

    getAllActiveUsers({
      take: takeNumber,
      skip: 0,
      filter: filterObj,
    });
  };

  return {
    changePage,
    getAllActiveUsers,
    filterUsers,
    activeUsers,
    pagination,
  };
};
